module.exports = __webpack_public_path__ + "static/media/AW.b314a163.svg";